import { useRef, useEffect } from "react";

// Ambient falling-leaves canvas. Gentle emerald/teal drifting leaves.
export default function LeavesCanvas({ enabled = true }) {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = window.innerWidth);
    let h = (canvas.height = window.innerHeight);

    const colors = ["#10B981", "#0D9488", "#34D399", "#059669", "#84CC16"];
    const COUNT = Math.min(26, Math.floor(w / 60));
    const leaves = Array.from({ length: COUNT }).map(() => spawn(true));

    function spawn(initial) {
      return {
        x: Math.random() * w,
        y: initial ? Math.random() * h : -30,
        size: 8 + Math.random() * 12,
        speed: 0.4 + Math.random() * 0.9,
        sway: 0.6 + Math.random() * 1.4,
        swayOffset: Math.random() * Math.PI * 2,
        rot: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.02,
        color: colors[(Math.random() * colors.length) | 0],
        opacity: 0.12 + Math.random() * 0.22,
      };
    }

    function drawLeaf(l) {
      ctx.save();
      ctx.translate(l.x, l.y);
      ctx.rotate(l.rot);
      ctx.globalAlpha = l.opacity;
      ctx.fillStyle = l.color;
      ctx.beginPath();
      ctx.moveTo(0, -l.size);
      ctx.bezierCurveTo(l.size, -l.size * 0.4, l.size, l.size * 0.4, 0, l.size);
      ctx.bezierCurveTo(-l.size, l.size * 0.4, -l.size, -l.size * 0.4, 0, -l.size);
      ctx.fill();
      ctx.strokeStyle = "rgba(255,255,255,0.5)";
      ctx.lineWidth = 0.6;
      ctx.beginPath();
      ctx.moveTo(0, -l.size);
      ctx.lineTo(0, l.size);
      ctx.stroke();
      ctx.restore();
    }

    let t = 0;
    function frame() {
      ctx.clearRect(0, 0, w, h);
      t += 0.016;
      for (let i = 0; i < leaves.length; i++) {
        const l = leaves[i];
        l.y += l.speed;
        l.x += Math.sin(t * l.sway + l.swayOffset) * 0.5;
        l.rot += l.rotSpeed;
        if (l.y > h + 40) leaves[i] = spawn(false);
        drawLeaf(l);
      }
      rafRef.current = requestAnimationFrame(frame);
    }
    frame();

    const onResize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    window.addEventListener("resize", onResize);
    return () => {
      cancelAnimationFrame(rafRef.current);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  if (!enabled) return null;
  return <canvas ref={canvasRef} className="leaves-canvas" data-testid="leaves-canvas" />;
}
